import normalizeApiError from '../utils/apiError';

import { engineApi } from './api';

// Public tenant config: { slug, name, settings: { allowedProvinces } }
export const getTenantConfig = async () => {
  try {
    const { data } = await engineApi.get('/tenant');
    return { success: true, data };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'getting tenant config',
      fallbackMessage: 'No pudimos cargar la configuración. Intentá nuevamente.'
    });
  }
};
